<script>
// assets/project/src/components/Base/BaseLocationCountryRegionCity.vue

import SearchAutocomplete from "./../Base/SearchAutocomplete";
import axios from "axios";
import SearchAutocompleteCities from "./../Base/SearchAutocompleteCities";
import {useLocationStore} from '@/stores/locationStore'

export default {
	name: "BaseLocationCountryRegionCity.vue",
	props: {
		labelCountry: {
			default: "Выберите страну"
		},
		labelCity: {
			default: "Выберите город"
		},
		labelRegion: {
			default: "Выберите регион"
		},
		labelAddress: {
			default: "Адрес (улица, дом, квартира)"
		},
		country: {
			default: ''
		},
		city: {
			default: ''
		},
		region: {
			default: ''
		},
		address: {
			default: ''
		},
		countryKey: {
			default: 'country'
		},
		cityKey: {
			default: 'city'
		},
		isCountryRequired: {
			type: Boolean,
			default: false
		},
		isCityRequired: {
			type: Boolean,
			default: false
		},
		isRegionRequired: {
			type: Boolean,
			default: false
		},
		isAddressRequired: {
			type: Boolean,
			default: false
		},
		//Данные обновляются в родительском компоненте
		isDataUpdating: {},
		showAddress: {
			type: Boolean,
			default: false
		},
	},
	async created() {
		this.countryField = this.country;
		this.regionField = this.region;
		this.cityField = this.city;
		this.addressField = this.address;
		
		await this.loadCountries();
		
		if (!this.country || this.country.length > 0) {
			this.loadCities();
		}
		
	},
	data() {
		return {
			countryField: '',
			regionField: '',
			cityField: '',
			addressField: '',
			//Список стран для отображения
			countriesinput: [],
			//Список городов для отображения
			citiestoinput: ''
		};
	},
	components: {
		SearchAutocomplete,
		SearchAutocompleteCities
	},
	computed: {
		cityDescription() {
			if (this.country !== '' && this.country !== 'Российская Федерация' && this.country !== 'Казахстан' && this.country !== 'Беларусь' && this.country !== 'Украина') {
				return 'Название указывается латинскими буквами';
			}
			return '';
		}
	},
	methods: {
		saveData() {
			//   Нужно т.к. есть связь в дочерних компонентах.
		},
		async loadCountries() {
			const locationStore = useLocationStore()
			
			try {
				const countries = await locationStore.fetchCountries()
				this.countriesinput = countries
			} catch (error) {
				console.log('Ошибка при загрузке стран:', error)
			}
		},
		async loadCities() {
			const current_country = this.countriesinput.filter((el) => {
				return el["ru_name"] === this.countryField;
			})
			
			if (current_country[0] && current_country[0].number) {
				const locationStore = useLocationStore()
				try {
					const cities = await locationStore.fetchCities(current_country[0].number)
					this.citiestoinput = cities
				} catch (error) {
					console.log('Ошибка при загрузке городов:', error)
					this.citiestoinput = []
				}
			}
		},
		async refreshCities(countryNumber) {
			// Удаляем города для конкретной страны
			delete this.cities[countryNumber]
			return this.fetchCities(countryNumber)
		},
		isFieldRequired(key) {
			return false
			//return this.$parent.isFieldRequired(key);
		},
		setRegion() {
			if (this.country === 'Российская Федерация') {
				const findItem = this.citiestoinput.find(el => el.ru_name === this.cityField);
				if (findItem) {
					this.regionField = findItem.region;
				}
			} else {
				this.regionField = '-';
			}
			this.$emit('update:region', this.regionField);
			this.$emit('onChange');
		},
		handleCityClick() {
			if (this.country === null || this.country.length === 0) {
				alert('Выберите страну выше');
				return;
			}
		},
		handleRegionClick() {
			if (this.country === null || this.country.length === 0) {
				alert('Выберите страну выше');
				return;
			}
			if (this.city === null || this.city.length === 0) {
				alert('Выберите город');
				return;
			}
			alert('Это поле заполняется автоматически')
		},
		countryChange() {
			this.$emit('update:country', this.countryField);
			
			if (this.countryField.length === 0) {
				this.regionField = '';
				this.cityField = '';
				this.$emit('update:region', '');
				this.$emit('update:city', '');
			}
			
			this.$emit('onChange');
			this.loadCities();
		},
		cityChange() {
			this.$emit('update:city', this.cityField);
			if (this.cityField.length === 0) {
				this.regionField = '';
				this.$emit('update:region', '');
			}
			
			this.setRegion();
			this.$emit('onChange');
		},
		addressChange() {
			this.$emit('update:address', this.addressField);
			this.$emit('onChange');
		},
	},
	watch: {
		// regionField(val) {
		//   this.$emit('update:region', val);
		//   this.$emit('onChange');
		// },
		// cityField(val) {
		//   this.$emit('update:city', val);
		//   this.$emit('onChange');
		// },
	}
}
</script>

<template>
	<div class="location_selector">
		<div class="country__wrapper">
			<SearchAutocomplete
				:items="countriesinput"
				:label="labelCountry"
				ref="predpolCountryAutocomlete"
				v-model="countryField"
				:objectKey="countryKey"
				:isDataUpdating="isDataUpdating"
				:is-required="isCountryRequired"
				@onChange="countryChange"
			/>
		</div>
		<div class="columns">
			<div class="column">
				<SearchAutocompleteCities
					:items="citiestoinput"
					ref="predpolCityAutocomlete"
					v-model="cityField"
					:label="labelCity"
					:objectKey="cityKey"
					:description="cityDescription"
					:isDataUpdating="isDataUpdating"
					@onChange="cityChange"
					@onBlur="cityField = ''"
					@cityClick="handleCityClick"
					:is-required="isCityRequired"
				>
				</SearchAutocompleteCities>
			</div>
			<div class="column">
				<div class="field">
					<label :class="isRegionRequired ? 'req' : ''">{{ labelRegion }}</label>
					<input :disabled="isDataUpdating" readonly @click="handleRegionClick" type="text"
					       v-model="regionField">
				</div>
			</div>
		</div>
		<div class="columns">
			<div class="column" v-if="showAddress">
				<div class="field">
					<label :class="isAddressRequired ? 'req' : ''">{{ labelAddress }}</label>
					<input
						type="text"
						v-model="addressField"
						:disabled="isDataUpdating"
						@input="addressChange"
					>
				</div>
			</div>
		</div>
	
	</div>
</template>

<style scoped>
.input_wrapper {
	position: relative;
}

.field input[type="text"] {
	padding-left: 30px;
}

.clearIcon {
	position: absolute;
	left: 10px;
	top: 14px;
	cursor: pointer;
}
</style>